"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagingToJSON = exports.PagingFromJSONTyped = exports.PagingFromJSON = exports.instanceOfPaging = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the Paging interface.
 */
function instanceOfPaging(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPaging = instanceOfPaging;
function PagingFromJSON(json) {
    return PagingFromJSONTyped(json, false);
}
exports.PagingFromJSON = PagingFromJSON;
function PagingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pageSize': !(0, runtime_1.exists)(json, 'page_size') ? undefined : json['page_size'],
        'totalResults': !(0, runtime_1.exists)(json, 'total_results') ? undefined : json['total_results'],
        'offset': !(0, runtime_1.exists)(json, 'offset') ? undefined : json['offset'],
        'currentPage': !(0, runtime_1.exists)(json, 'current_page') ? undefined : json['current_page'],
    };
}
exports.PagingFromJSONTyped = PagingFromJSONTyped;
function PagingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'page_size': value.pageSize,
        'total_results': value.totalResults,
        'offset': value.offset,
        'current_page': value.currentPage,
    };
}
exports.PagingToJSON = PagingToJSON;
